export const getUserInitials = (firstName: string, lastName: string) =>
  firstName?.charAt(0) + lastName?.charAt(0);
